import { render } from "./achievementList.vue?vue&type=template&id=10ccb3fe&scoped=true"
import script from "./achievementList.vue?vue&type=script&lang=js"
export * from "./achievementList.vue?vue&type=script&lang=js"

import "./achievementList.vue?vue&type=style&index=0&id=10ccb3fe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10ccb3fe"]])

export default __exports__